import React, { useState } from "react";
import "./partslistpopup.css";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import { useTranslation } from "react-i18next";


const Partlistpopup = ({ handleClose ,downloadParts}) => {
    const { i18n, t } = useTranslation();
    return (
        <>
            {/* <div className="part-list-container"> */}

            <div className="partlist-popup">
          <div className="popup-content">

          <h2>{t('partsbulk.generalstep')}</h2>
                <div className="list">
                    <ul>
                       <li>{t('partsbulk.createexcelfile')}</li>
                    </ul>
                </div>
                <div className="excel-container">
                    <img src={Image_Url.EXCELPHOTO}/>
                </div>
                <div className="list">
                    <ul>
                        <li>{t('partsbulk.loginwebportal')}</li>
                        <li>{t('partsbulk.lookforoption')}</li>
                        <li>{t('partsbulk.clickonoption')}</li>
                        <li>{t('partsbulk.onceselectedfile')}</li>
                        <li>{t('partsbulk.waitforportal')}</li>
                        <li>{t('partsbulk.confirmationmsg')}</li>
                    </ul>
                </div>
                <div className="btn_ss">
                <button className="dexcel" onClick={downloadParts}>
            <img src={Image_Url.DEXCEL} className="downloads_imgdexcel" />
           {t('partlist.partsinbulk')}
            </button>
                    <button className="btn_2" onClick={handleClose}>{t('addparts.close')}</button>
                </div>

          </div>
        </div>
                

            {/* </div> */}

        </>
    );
};

export default Partlistpopup;
